var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.9293 14.3863L38.6188 1.0758C38.1844 0.6414 37.4827 0.6414 37.0483 1.0758L0.580882 37.5432C0.146481 37.9776 0.146481 38.6793 0.580882 39.1137L13.8914 52.4242C14.3258 52.8586 15.0275 52.8586 15.4619 52.4242L51.9293 15.9568C52.3637 15.5224 52.3637 14.8207 51.9293 14.3863ZM14.6711 50.0628L2.94224 38.334L11.7528 29.5235L15.7515 33.5222C16.1748 33.9677 16.8876 33.9789 17.322 33.5445C17.7676 33.1212 17.7787 32.4083 17.3443 31.9739C17.3332 31.9628 17.3332 31.9628 17.322 31.9517L13.3233 27.9641L16.2304 25.057L22.468 31.2945C22.9024 31.7289 23.6153 31.7289 24.0385 31.2834C24.4729 30.849 24.4729 30.1472 24.0385 29.7128L17.801 23.4753L20.7081 20.5681L24.7068 24.5557C25.1412 24.9901 25.843 24.9901 26.2774 24.5557C26.7118 24.1213 26.7118 23.4196 26.2774 22.9852L22.2786 18.9976L25.1858 16.0905L31.4233 22.328C31.8577 22.7624 32.5595 22.7624 32.9939 22.328C33.4283 21.8936 33.4283 21.1919 32.9939 20.7575L26.7563 14.5199L29.6635 11.6128L33.6622 15.6115C34.0966 16.0459 34.7983 16.0571 35.2327 15.6227C35.6671 15.1883 35.6782 14.4865 35.2438 14.0521C35.2438 14.0521 35.2438 14.0521 35.2327 14.041L31.2674 10.0089L34.1745 7.10172L40.4121 13.3393C40.8465 13.7737 41.5482 13.7737 41.9826 13.3393C42.417 12.9049 42.417 12.2031 41.9826 11.7687L35.7451 5.53119L37.8391 3.43716L49.5679 15.166L14.6711 50.0628Z",
    fill: "url(#paint0_linear_5543_13725)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5543_13725",
    x1: 26.2551,
    y1: 0.75,
    x2: 38.5552,
    y2: 67.2802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A175FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#563AFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasureIcon);
export default __webpack_public_path__ + "static/media/MeasureIcon.f9c97b6140f3a166a76a110db159257e.svg";
export { ForwardRef as ReactComponent };